/**
 * Wirft bei Fehlerantworten (z. B. 503, wenn die externe Sagasser-Datenbank deaktiviert ist) einen Error mit
 * der Servermeldung, damit der Importablauf abbricht statt stillschweigend weiterzulaufen.
 */
async function throwIfNotOk(response) {
  if (response.ok) {
    return true
  }

  let errors = []

  try {
    const body = await response.json()
    errors = body.errors || (body.message ? [ body.message ] : [])
  } catch (e) {
    // kein JSON-Body
  }

  const error = new Error(errors.length ? errors.join('\n') : `HTTP ${response.status}`)
  error.status = response.status
  error.errors = errors

  throw error
}

export default class QuantityService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  async clear(options) {
    const response = await fetch(`${this.baseUrl}/quantity/all`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async import(options) {
    const response = await fetch(`${this.baseUrl}/quantity/import/sql/`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await throwIfNotOk(response)
  }
}